import {
    AUDIO_RESUME,
    AUDIO_PAUSE,
    GAME_COMMAND,
    OPEN_HOME,
    OPEN_LINK,
    OPEN_NEWS_ARTICLE,
    PLAY_SOUND,
    REFRESH_JWT,
    SHOW_BACK_BUTTON,
    OPEN_ESPORT_ARTICLE,
    BRIDGE_FUNCTION,
} from "supercell-frontend-base/src/constants/types/commands";
import slugify from "slugify";
import {
    mutateOpenLinkHack,
    OpenLinkPayload,
} from "supercell-frontend-base/src/utils/hack-mutate-open-link";
import { deepLinkSchema } from "inbox-contentful";
import { bridge } from "supercell-frontend-base/src/utils/bridge";

const protocol = deepLinkSchema.brawlstars;

const mutateOpenLink = mutateOpenLinkHack(protocol);

export const commander =
    (
        sendGameCommand: (command: string) => void,
        trackLinkClick: (data: Record<string, string>) => void,
    ) =>
    (navigate: (path: string) => void) =>
    (type: string, payload: OpenLinkPayload) => {
        if (type === OPEN_LINK) ({ type, payload } = mutateOpenLink(payload));

        switch (type) {
            case OPEN_HOME:
                return navigate("/");
            case OPEN_NEWS_ARTICLE:
                return navigate(
                    `/${payload.lang}/news/${payload.id}/${slugify(
                        payload.slug ?? "",
                        {
                            strict: true,
                            lower: true,
                        },
                    )}`,
                );
            case OPEN_ESPORT_ARTICLE:
                return navigate(
                    `/${payload.lang}/esport/${payload.id}/${slugify(
                        payload.slug ?? "",
                        {
                            strict: true,
                            lower: true,
                        },
                    )}`,
                );
            case OPEN_LINK:
                trackLinkClick({
                    url: payload.url,
                    id: payload.id || "",
                    label: payload.label || "",
                });

                return sendGameCommand(
                    `${protocol}://OpenWeb?url=${encodeURIComponent(
                        encodeURIComponent(payload.url),
                    )}`,
                );
            case PLAY_SOUND:
                return sendGameCommand(
                    `${protocol}://playSound?name=${payload}`,
                );
            case AUDIO_PAUSE:
                return sendGameCommand(`${protocol}://StopMusic`);
            case AUDIO_RESUME:
                return sendGameCommand(`${protocol}://ResumeMusic`);
            case SHOW_BACK_BUTTON:
                return sendGameCommand(
                    `${protocol}://backButton?state=${
                        payload ? "show" : "hide"
                    }`,
                );
            case GAME_COMMAND: {
                trackLinkClick({
                    url: payload.url,
                    id: payload.id || "",
                    label: payload.label || "",
                    additionalInformation: payload.additionalInformation,
                });
                return sendGameCommand(payload.url);
            }
            case REFRESH_JWT:
                return sendGameCommand(`${protocol}://tokenExpired`);
            case BRIDGE_FUNCTION:
                return bridge().then((bridge) => {
                    if (
                        payload.functionName &&
                        payload.functionName in bridge
                    ) {
                        bridge[payload.functionName](
                            ...(payload.functionArgs || []),
                        );
                    }
                });
            default:
                return console.error(`Command not recognized "${type}"`);
        }
    };
